<template>
    <div class="nav-bar">
        <div class="nav-left">
            <a-icon :type="collapsed ? 'menu-unfold' : 'menu-fold'" class="collapsed-icon" @click="changeCollapsed"/>
        </div>
        <a-space class="nav-user" @click.stop="showMenu" v-if="login">
            <img src="../assets/avatar.png" class="nav-avatar">
            <div class="user-name">
                <div class="name-txt">{{ username || '管理员'}}</div>
            </div>
            <div class="icon-down"></div>
        </a-space>
        <div class="down-box" v-show="ms">
            <div class="down-box-item" @click.stop="logout">
                <a-icon type="logout" />
                <div class="down-txt">退出登录</div>
            </div>
        </div>
    </div>
</template>

<script>
    import {cleanToken, getUserName} from "../common/js/storage";
    import { base } from "../router";

    export default {
        name: "nav-bar",
        data() {
            return {
                menu: [],
                ms: false,
                username: getUserName()
            }
        },
        computed: {
            login () {
                return this.$store.getters.login;
            },
            collapsed () {
                return this.$store.getters.collapsed;
            }
        },
        created() {
            document.addEventListener('click', this.hideMenu, false);
        },
        beforeDestroy() {
            document.removeEventListener('click', this.hideMenu, false);
        },
        methods: {
            changeCollapsed() {
                this.$store.commit("changeCollapsed", !this.collapsed);
            },
            logout() {
                cleanToken();
                location.replace(base + '/login');
            },
            showMenu() {
                this.ms = !this.ms;
            },
            hideMenu() {
                this.ms = false;
            }
        }
    }
</script>

<style lang="less">
    .nav-bar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        padding: 0 @padding-md;
        height: 64px;
        background-color: @body-background;
        box-shadow: @box-shadow-base;
        z-index: 10;
    }
    .logo {
        display: flex;
        align-items: center;
        height: 100%;
    }
    .collapsed-icon {
        font-size: 20px;
        cursor: pointer;
    }
    .nav-user {
        position: relative;
        padding: 0 8px;
        height: 100%;
        cursor: pointer;
        line-height: 1;
        &:hover {
            background-color: @background-color-light;;
        }
    }
    .name-auth {
        margin-top: 4px;
        color: var(--back-font-color);
        font-size: 12px;
    }
    .user-down {
        margin-left: 4px;
        font-size: 16px;
    }
    .name-down {
        font-size: 12px;
    }
    .down-box {
        position: absolute;
        top: 68px;
        right: 24px;
        min-width: 160px;
        border: var(--border);
    }
    .down-box-item {
        display: flex;
        align-items: center;
        padding: @padding-sm @padding-md;
        cursor: pointer;
        &:hover {
            background-color: @background-color-light;;
        }
    }
    .down-txt {
        margin-left: 8px;
    }
</style>
